require('./creditPregrantedLimitVariationView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
//@actions
const CreditPregrantedLimitVariationActions = require('actions/credits/creditPregrantedLimitVariation');
const hireCardCreditINEActions = require('actions/commons/hireCardCreditINE');
const printedActions = require("actions/contactCenter/printer");
const mortgageRequestHolderConfirmation = require("actions/mortgageRequest/mortgageRequestHolderConfirmation");
const profile = require('actions/profile');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { AmountInput } = require('commonsComponents/amountInput');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

//@components
const CreditPregrantedLimitVariationStep = require('components/credits/creditPregrantedLimitVariationStep/creditPregrantedLimitVariationStep');
const CreditPregrantedLimitVariationSuccess = require('components/credits/creditPregrantedLimitVariationSuccess/creditPregrantedLimitVariationSuccess');
const CreditPregrantedLimitVariationFailure = require('components/credits/creditPregrantedLimitVariationFailure/creditPregrantedLimitVariationFailure');
const HireCardOpenCreditStepINE = require('components/hire/cardINEDocument/hireCardOpenCreditStepINE');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

//@utilities
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { getCurrencySymbol } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');
//@constants
const { CREDIT_PREGRANTED_VARIATION_LIMIT } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER, GRAPHIC_TUTOR_TYPE_4, WIZARD_SECOND_STEP, OVERDRAFT_LOAN_STANDARD, OVERDRAFT_LOAN_SUBTYPE, OVERDRAFT_LOAN_TYPE } = require('constants/index');
const { NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES } = require('constants/flagBasedFeatures');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const ContactCenterNewValidationCards = require('components/hire/contactCenterValidationCards/contactCenterNewValidationCards');

class CreditPregrantedLimitVariationView extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.setLimit = this.setLimit.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleConfirmationChange = this.handleConfirmationChange.bind(this);

    }

    componentDidMount() {
        const { match: { params: { creditId } }, immCredits, history, getAccount } = this.props;
        const immCredit = immCredits.getIn(['byId', creditId]);
        getAccount(creditId)
        if (!immCredit.has('details')) {
            history.push(`/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`);
        }
    }

    componentWillUnmount() {
        this.props.clear();
    }

    setLimit(value) {
        const { immFlagBasedFeatures } = this.props;
        const newFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES);

        if (newFF) {
            if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
                this.props.setLimit(value);

            } else {

                this.props.setNewFFLimit(value)
            }
        } else {
            this.props.setLimit(value);
        }

    }


    buildError() {
        return (
            <div className="card-modify-limit__operation-result-state">
                <CreditPregrantedLimitVariationFailure />
            </div>
        );
    }

    buildSuccess(immCredit, newLimit) {
        return (
            <div className="card-modify-limit__operation-result-state">
                <CreditPregrantedLimitVariationSuccess immCredit={immCredit} newLimit={newLimit} />
            </div>
        );
    }
    openPdfInNewTab(documentKey) {
        const { immPregrantedCreditLimitVariation } = this.props;
        const document = immPregrantedCreditLimitVariation.get(documentKey);
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
    }
    handleOpenPdfINENewTab() {
        this.openPdfInNewTab('fileINEDocument');
    }
    handleDownloadPdf() {
        const { immPregrantedCreditLimitVariation } = this.props;
        const document = immPregrantedCreditLimitVariation.get('filePolicyDocument');
        const base64 = document;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = formatText(`creditPregrantedLimitVariationStep-documentPolicy`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }
    handleOnPrint() {
        const { immPregrantedCreditLimitVariation, printDocumentPolicy } = this.props;
        const document = immPregrantedCreditLimitVariation.get('filePolicyDocument');
        if (document) {
            const base64 = document;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            printDocumentPolicy()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    handleDocumentReaded() {
        const { scrollDocumentPolicy } = this.props;
        scrollDocumentPolicy();
    }
    buildViewer() {
        const { immPregrantedCreditLimitVariation } = this.props;

        const documentINE = immPregrantedCreditLimitVariation.get('filePolicyDocument');
        if (documentINE) {
            let title = formatText(`overdraftProtectionLoan-acceptanceTextCC`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (

                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />

            );
        } else {
            return <LoadingSection />;
        }
    }
    buildINE() {
        const { immPregrantedCreditLimitVariation, cardsConfimationScrollDown, checkCheckedDocument,
            printedAndSignedRadioChanged, enableButtonOffice, checkRadioButton, immPrinter, overdraftPrintInit } = this.props;
        const documentINE = immPregrantedCreditLimitVariation.get('fileINEDocument')
        const scrollDown = immPregrantedCreditLimitVariation.get('scrollDown')
        const agreeIneCheckbox = immPregrantedCreditLimitVariation.get('agreeIneCheckbox')
        const checkButtonRadio = immPregrantedCreditLimitVariation.get('checkButtonRadio')
        const printDocument = immPregrantedCreditLimitVariation.get('printDocument')
        const documentsPrintedAndSigned = immPregrantedCreditLimitVariation.get('cardsDocumentsPrintedAndSigned')

        return (

            <HireCardOpenCreditStepINE
                documentINE={documentINE}
                cardsConfimationScrollDown={cardsConfimationScrollDown}
                scrollDown={scrollDown}
                checkCheckedDocument={checkCheckedDocument}
                agreeIneCheckbox={agreeIneCheckbox}
                printedAndSignedRadioChanged={printedAndSignedRadioChanged}
                enableButtonOffice={enableButtonOffice}
                checkRadioButton={checkRadioButton}
                checkButtonRadio={checkButtonRadio}
                hireCardOpenCreditprintDocument={overdraftPrintInit}
                printDocument={printDocument}
                immPrinter={immPrinter}
                documentsPrintedAndSigned={documentsPrintedAndSigned}
                documentDownloadName={'creditPregrantedLimitVariationStep-documentINE'}

            />
        );
    }
    onHandleChangeCheckBox(evt) {
        const { handleAgreementCheckboxChange } = this.props;

        return handleAgreementCheckboxChange(evt, FOURTH_STEP)
    }
    buildLegalConfirmationSection(showRevolvingDocument, amount) {
        const { immPregrantedCreditLimitVariation, onHandleChangeCheckBoxCC, processEmail } = this.props;

        const precontractualMailProductInfo = {
            producto: OVERDRAFT_LOAN_TYPE,
            standard: OVERDRAFT_LOAN_STANDARD,
            subproducto: OVERDRAFT_LOAN_SUBTYPE,
        }
        const immStep = immPregrantedCreditLimitVariation.get(['steps', WIZARD_SECOND_STEP]);
        const agreementLabel = <FormattedText value={'hireCardNeruda-hireCardNeruda_step4NewCheckboxText'} />;
        const agreementErrorMsg = formatText('hireCardNeruda-hireCardNeruda_step4CheckboxErrorMsg');
        const documentINE = immPregrantedCreditLimitVariation.get('fileINEDocument')
        const documentPolicy = immPregrantedCreditLimitVariation.get('filePolicyDocument')
        const newIntLoading = documentINE && documentPolicy
        const sendMailParams = {
            type: OVERDRAFT_LOAN_TYPE,
            subType: OVERDRAFT_LOAN_SUBTYPE,
            standar: OVERDRAFT_LOAN_STANDARD,

        };
        return (
            documentPolicy &&
            <ContactCenterNewValidationCards
                amount={amount}
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName="visa-open"
                handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                isContractingProcess
                immStep={immStep}
                precontractualMailProductInfo={precontractualMailProductInfo}
                sendMailParams={sendMailParams}
                showIneAndRevolving={true}
                showRevolvingDocument={showRevolvingDocument}
                processEmail={processEmail}
                immHireCardOpenCredit={immPregrantedCreditLimitVariation}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                ineNotCall={true}
                newIntLoading={newIntLoading}
                newCardsFF={true}
            />
        )

    }
    handleConfirmationChange() {
        const { updateConfirmationCheckbox } = this.props;
        updateConfirmationCheckbox();
    }
    buildLabels() {
        const { immPreGrantedCredit } = this.props;

        const labels = [];
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel1'));
        labels.push(
            <OKLink
                onClick={() => this.openDynamicDocument(immPreGrantedCredit.get('fileINEDocument'))}
                modifier="emphasize"
            >
                {formatText('contractsView-preGrantedCreditServiceContractLabel2')}
            </OKLink>
        );
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel3'));
        labels.push(
            <OKLink
                target="_blank"
                to={formatText('contractsView-pdfLinkforCPS')}
                modifier="emphasize"
            >
                {formatText('contractsView-preGrantedCreditServiceContractLabel4')}
            </OKLink >
        );
        labels.push(formatText('contractsView-preGrantedCreditServiceContractLabel5'));

        return labels;
    }


    buildLegalConfirmation() {
        const { immPregrantedCreditLimitVariation, immProfile, preContractualMail, requestProfile, sendOverDraftSimpleEmail } = this.props;

        const sendMail = immPregrantedCreditLimitVariation.get('sendMail')
        const fileINEDocumentId = immPregrantedCreditLimitVariation.get('fileINEDocumentId')
        const clientEmail = fileINEDocumentId ? PersonalDataHelper.getEmail(immProfile) : false;
        const profileError = immProfile.get('error');
        return (
            <>
                <PreContractualMailInfo
                    contractName={"pre-granted-credit"}
                    email={clientEmail}
                    preContractualMail={preContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendOverDraftSimpleEmail}
                    showLegalText={false}
                    hasBeenSentEmail={sendMail}
                />
                {sendMail &&
                    <OKCheckbox
                        idName="serviceContract"
                        value={immPregrantedCreditLimitVariation.get('confirmationCheckCc')}
                        onChange={this.handleConfirmationChange}
                        label={formatText('hireCardOpenCredit-step4NewCheckboxText')}
                        errorState={!immPregrantedCreditLimitVariation.get('confirmationCheckbox') && immPregrantedCreditLimitVariation.get('confirmationCheckboxError')}
                        errorMessage={!immPregrantedCreditLimitVariation.get('confirmationCheckbox') && formatText('contractsView-serviceContractErrorMessage')}
                    />
                }


            </>
        );
    }
    buildWizard(immCredit, immPregrantedCreditLimitVariation) {
        const { validateStep, setVisibleStep, immAccounts, immFlagBasedFeatures, immProfile } = this.props;
        const newFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES);
        const immAccount = immAccounts.get('byId').get(immCredit.get('accountId'));
        const immNewSteps = __CONTACT_CENTER__ && !isPrintOfficeMode() ? immPregrantedCreditLimitVariation.get('steps') : immPregrantedCreditLimitVariation.get('newSteps');
        const immSteps = newFF ? immNewSteps : immPregrantedCreditLimitVariation.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: this.handleCancel,
            finish: this.handleFinish
        };

        const currency = immCredit.getIn(['available', 'currency']);
        const currencySign = getCurrencySymbol(immCredit.get('available'));

        const newLimit = immPregrantedCreditLimitVariation.get('newLimit');
        const errorLimitIsVisiblenewSteps = __CONTACT_CENTER__ && !isPrintOfficeMode() ? !immPregrantedCreditLimitVariation.getIn(['steps', 0, 'valid']) && immPregrantedCreditLimitVariation.get('newLimitIsDirty') : !immPregrantedCreditLimitVariation.getIn(['newSteps', 0, 'valid']) && immPregrantedCreditLimitVariation.get('newLimitIsDirty')
        const errorLimitIsVisible = newFF ? errorLimitIsVisiblenewSteps : !immPregrantedCreditLimitVariation.getIn(['steps', 0, 'valid']) && immPregrantedCreditLimitVariation.get('newLimitIsDirty')
        const errorLimitValidationMsg = formatText('creditPregrantedLimitVariationStep-validationMsg', [immCredit.getIn(['available', 'amount'])]);
        const agreeIneCheckbox = immPregrantedCreditLimitVariation.get('agreeIneCheckbox')
        const checkButtonRadio = immPregrantedCreditLimitVariation.get('checkButtonRadio')
        const printPolicyDocument = immPregrantedCreditLimitVariation.get('printDocumentPolicy')
        const confirmationCheckCc = immPregrantedCreditLimitVariation.get('confirmationCheckCc')
        const operationParams = {
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immCredit.get('product') + immCredit.get('contractNumber'),
            ammount: newLimit
        };
        const name = PersonalDataHelper.getFullName(immProfile, false);
        const keyName = `<b>${name}</b>`;
        const isContactCenterWithOverdraftProtection = (__CONTACT_CENTER__ && !isPrintOfficeMode());
        const documentViewSection = isContactCenterWithOverdraftProtection ? this.buildLegalConfirmation() : null;
        const documentPolicy = immPregrantedCreditLimitVariation.get('filePolicyDocument')
        const initAmount = immCredit.getIn(['available', 'amount'])

        const commonSteps = [
            <WizardStep position="first" cancelButton={true} nextButtonDisabled={initAmount === newLimit}>
                <CreditPregrantedLimitVariationStep
                    immCredit={immCredit}
                    immAccount={immAccount}
                    titleKey="creditPregrantedLimitVariationStep-stepOneTitle"
                    confirmationScriptNone={newFF}
                >
                    <section className="credit-pregranted-limit-variation__input-section">
                        <FormattedText
                            className="credit-pregranted-limit-variation__input-subtitle"
                            value="creditPregrantedLimitVariationStep-newLimit"
                        />
                        <div className="credit-pregranted-limit-variation__input">
                            <AmountInput
                                id="inp_creditPregrantedLimitStepOne_newLimit"
                                amount={newLimit}
                                callback={this.setLimit}
                                error={errorLimitIsVisible}
                                errorMsg={errorLimitValidationMsg}
                                showBlurZero
                                hideFocusZero
                                disablePaste
                                language={getLanguage()}
                            />
                        </div>
                        <span className="credit-pregranted-limit-variation__currency-sign">
                            {currencySign}
                        </span>
                    </section>
                </CreditPregrantedLimitVariationStep>
            </WizardStep>,
            newFF ?
                __CONTACT_CENTER__ && !isPrintOfficeMode() ?
                    <WizardStep
                        position="last"
                        cancelButton={true}
                        addLoadingBehaviour={true}
                        immFinalButton="common-confirm"
                        isLoading={immPregrantedCreditLimitVariation.get('inProgress')}
                        finalButtonDisabled={confirmationCheckCc ? false : true}
                    >

                        <CreditPregrantedLimitVariationStep
                            immCredit={immCredit}
                            immAccount={immAccount}
                            showNewLimitField={true}
                            newLimit={newLimit}
                            titleKey="creditPregrantedLimitVariationStep-stepTwoTitle"
                            subtitleKey="creditPregrantedLimitVariationStep-checkDataSubtitle"
                            confirmationScriptNone={true}
                            newFF={newFF}
                            keyName={keyName}

                        >
                            <div className="hire-card-neruda-step-five__pdf-viewer-container">

                                <div>
                                    <h4 className="contract-loan-pdf-viewer__subtitle">
                                        <strong>
                                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                                        </strong>
                                    </h4>
                                </div>
                            </div>

                            {documentViewSection}
                            <section className="credit-pregranted-limit-variation__input-section credit-pregranted-limit-variation__input-section--signature-pattern">


                                {documentPolicy &&
                                    <SignaturePattern
                                        operationType={CREDIT_PREGRANTED_VARIATION_LIMIT}
                                        operationParams={operationParams}
                                    />
                                }
                            </section>
                        </CreditPregrantedLimitVariationStep>
                    </WizardStep>
                    :
                    <WizardStep
                        position="last"
                        cancelButton={true}
                        addLoadingBehaviour={true}
                        immFinalButton="common-confirm"
                        isLoading={immPregrantedCreditLimitVariation.get('inProgress')}
                    >

                        <CreditPregrantedLimitVariationStep
                            immCredit={immCredit}
                            immAccount={immAccount}
                            showNewLimitField={true}
                            newLimit={newLimit}
                            titleKey="creditPregrantedLimitVariationStep-stepTwoTitle"
                            subtitleKey="creditPregrantedLimitVariationStep-checkDataSubtitle"
                        >
                            <div className="hire-card-neruda-step-five__pdf-viewer-container">

                                <div>
                                    <h4 className="contract-loan-pdf-viewer__subtitle">
                                        <strong>
                                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                                        </strong>
                                    </h4>
                                    <div className="contract-actions-readed contract-payrollLoan-readed">
                                        <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfINENewTab()}>
                                            <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                                        </button>
                                        <span>
                                            <i className="signature-pattern-code-input__icon icon icon-check " />
                                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                                        </span>
                                    </div>
                                </div>
                                {this.buildViewer()}
                            </div>

                            <section className="credit-pregranted-limit-variation__input-section credit-pregranted-limit-variation__input-section--signature-pattern">

                                {__CONTACT_CENTER__ && isPrintOfficeMode() && printPolicyDocument &&
                                    <SignaturePattern
                                        operationType={CREDIT_PREGRANTED_VARIATION_LIMIT}
                                        operationParams={operationParams}
                                        isEasyLoanTypeAB={isPrintOfficeMode() && true}
                                    />
                                }
                                {!isPrintOfficeMode() && documentPolicy &&
                                    <SignaturePattern
                                        operationType={CREDIT_PREGRANTED_VARIATION_LIMIT}
                                        operationParams={operationParams}
                                    />
                                }
                            </section>
                        </CreditPregrantedLimitVariationStep>
                    </WizardStep>
                :

                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton="common-confirm"
                    isLoading={immPregrantedCreditLimitVariation.get('inProgress')}
                >
                    <CreditPregrantedLimitVariationStep
                        immCredit={immCredit}
                        immAccount={immAccount}
                        showNewLimitField={true}
                        newLimit={newLimit}
                        titleKey="creditPregrantedLimitVariationStep-stepTwoTitle"
                        subtitleKey="creditPregrantedLimitVariationStep-checkDataSubtitle"
                    >
                        <section className="credit-pregranted-limit-variation__input-section credit-pregranted-limit-variation__input-section--signature-pattern">
                            <SignaturePattern
                                operationType={CREDIT_PREGRANTED_VARIATION_LIMIT}
                                operationParams={operationParams}
                            />
                        </section>
                    </CreditPregrantedLimitVariationStep>
                </WizardStep>
        ];
        const newSteps = newFF && (__CONTACT_CENTER__ && isPrintOfficeMode() || !__CONTACT_CENTER__) ? [
            ...commonSteps.slice(0, 1),
            <WizardStep
                cancelButton={true}
                onBackClick={false}
                position="middle"
                nextButtonDisabled={isPrintOfficeMode() ? !checkButtonRadio : !agreeIneCheckbox}
                immFlagBasedFeatures={immFlagBasedFeatures}
            >
                {this.buildINE()}
            </WizardStep>,
            ...commonSteps.slice(1)
        ] : commonSteps;
        return (
            <Wizard
                fullWidth={true}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immPregrantedCreditLimitVariation.get('visibleStep')}
                showPreLeaveModal={true}
            >
                {newSteps}
            </Wizard>
        );
    }

    handleCancel() {
        const { creditId } = this.props.match.params;
        this.props.history.push(`/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`);
    }

    handleFinish() {
        const { match: { params: { creditId } }, setNewLimit } = this.props;
        setNewLimit(creditId);
    }

    render() {
        const { match: { params: { creditId } }, immCredits, immPregrantedCreditLimitVariation } = this.props;
        const immCredit = immCredits.getIn(['byId', creditId]);
        let bodyContent;
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('breadcrumb-pregrantedCredit', [getLastNChars(immCredit.get('iban'), 4, '.', 4)]),
                url: `/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`
            },
            {
                text: formatText('breadcrumb-creditsPregrantedModifyLimit'),
                url: `/myprofile/loans-mortgages/credits/${creditId}/credit-pregranted-modify-limit`

            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-loansLimitTitle')}
            />
        );

        if (immCredit) {
            if (immPregrantedCreditLimitVariation.get('error')) {
                bodyContent = this.buildError();
            } else if (immPregrantedCreditLimitVariation.get('success')) {
                bodyContent = this.buildSuccess(immCredit, immPregrantedCreditLimitVariation.get('newLimit'));
            } else {
                bodyContent = this.buildWizard(immCredit, immPregrantedCreditLimitVariation);
            }
        }

        let content = <LoadingSection />;

        content = (
            <article className="credit-pregranted-limit-variation">
                <OKCover size="medium" section="loansmortgages">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        tutorial={tutorial}
                        finalTitle={getFinalTitle('creditPregrantedLimitVariation-title')}
                    />
                </OKCover>
                <section className="credit-pregranted-limit-variation__body">
                    {bodyContent}
                </section>
            </article>
        );

        return content;
    }
}

CreditPregrantedLimitVariationView.propTypes = {
    history: PropTypes.object.isRequired,
    immCredits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setLimit: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    setNewLimit: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    immPregrantedCreditLimitVariation: PropTypes.object.isRequired
};

module.exports.constructor = CreditPregrantedLimitVariationView;
module.exports.CreditPregrantedLimitVariationView = connect(state => ({
    immCredits: state.creditsPregranted,
    immAccounts: state.accounts,
    immPregrantedCreditLimitVariation: state.creditPregrantedLimitVariation,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immProfile: state.profile,
    preContractualMail: state.preContractualMail,


}),
    {
        clear: CreditPregrantedLimitVariationActions.clear,
        setLimit: CreditPregrantedLimitVariationActions.setLimit,
        setNewFFLimit: CreditPregrantedLimitVariationActions.setNewFFLimit,
        validateStep: CreditPregrantedLimitVariationActions.validateStep,
        setVisibleStep: CreditPregrantedLimitVariationActions.setVisibleStep,
        getAccount: CreditPregrantedLimitVariationActions.getAccount,
        overdraftPrintInit: CreditPregrantedLimitVariationActions.overdraftPrintInit,
        checkRadioButton: CreditPregrantedLimitVariationActions.checkRadioButton,
        printDocumentPolicy: CreditPregrantedLimitVariationActions.printDocumentPolicy,
        scrollDocumentPolicy: CreditPregrantedLimitVariationActions.scrollDocumentPolicy,
        setNewLimit: CreditPregrantedLimitVariationActions.setNewLimit,
        onHandleChangeCheckBoxCC: CreditPregrantedLimitVariationActions.onHandleChangeCheckBoxCC,
        updateConfirmationCheckbox: CreditPregrantedLimitVariationActions.updateConfirmationCheckbox,
        sendOverDraftSimpleEmail: CreditPregrantedLimitVariationActions.sendOverDraftSimpleEmail,
        handleAgreementCheckboxChange: CreditPregrantedLimitVariationActions.setAgreementCheckbox,
        processEmail: CreditPregrantedLimitVariationActions.processEmail,
        cardsConfimationScrollDown: hireCardCreditINEActions.cardsConfimationScrollDown,
        cardsConfimationScrollDownPolicy: hireCardCreditINEActions.cardsConfimationScrollDownPolicy,
        checkCheckedDocument: hireCardCreditINEActions.checkCheckedDocument,
        printedAndSignedRadioChanged: printedActions.printedAndSignedRadioChanged,
        enableButtonOffice: mortgageRequestHolderConfirmation.enableButtonOffice,
        requestProfile: profile.requestProfile,
        requestProfile: profile.requestProfile,


    })(withRouter(CreditPregrantedLimitVariationView));
